import React, { ReactNode } from 'react';
import styled from 'styled-components';
import Slider from 'react-slick';
import { TIPS } from '../../utils/constants';

const AdBoxContainer = styled.div`
  background: ${({ theme }) => theme.colors.primary};
  padding: 40px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  max-width: 350px;
  p {
    line-height: 2;
    text-align: center;
  }
  a {
    color: white;
    text-decoration: none;
  }
`;
const TextContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  color: white;
  h1 {
    text-transform: uppercase;
  }
  p {
    color: white;
  }
`;
const Content = styled.div`
  width: 100%;
`;

const settings = {
  dots: false,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  initialSlide: 1,
  arrows: false,
  autoplay: true,
  autoplaySpeed: 4000,
};

type TipsCard = {
  children: ReactNode;
};
const TipsCard = ({ children }: TipsCard) => {
  return (
    <AdBoxContainer>
      <TextContent>
        <h1>Security Tips</h1>
        <Content>
          <Slider {...settings}>
            {TIPS.map((tip, indx) => {
              return <p key={indx}>{tip}</p>;
            })}
          </Slider>
        </Content>
      </TextContent>
      {children}
    </AdBoxContainer>
  );
};
export default TipsCard;
